import React from 'react';
import Footer from '../Components/Footer';
import Navbar from '../Components/Navbar';
import { Link } from 'react-router-dom';

function WorkWithUs() {
  return (
    <>
      <Navbar />
      <div className='banner banner2'>
        <h2>Work With Us</h2>
        <p>Home / Work With Us</p>
      </div>
      
      <div className='work-container'>
        <div className='work-section'>
          <div className='work-card'>
            <h2>Courses</h2>
            <p>Explore our comprehensive courses designed to help you master new skills and advance your career. Our expert-led programs cover a wide range of topics to meet your learning needs.</p>
            <Link to="/courses" className='work-button'>Explore Courses</Link>
          </div>
          
          <div className='work-card'>
            <h2>Workshop</h2>
            <p>Join our interactive workshops to gain hands-on experience and practical knowledge. Our workshops are designed to provide valuable insights and real-world applications.</p>
            <Link to="/workshop" className='work-button'>View Workshops</Link>
          </div>
          
          <div className='work-card'>
            <h2>Angel Investing</h2>
            <p>Discover exciting investment opportunities with our Angel Investing program. Connect with innovative startups and be part of their growth journey while earning potential returns.</p>
            <Link to="/angel-investing" className='work-button'>Learn More</Link>
          </div>
          
          <div className='work-card'>
            <h2>Book a Call</h2>
            <p>Schedule a one-on-one consultation with our experts to discuss your specific needs and how we can help you achieve your goals.</p>
            <Link to="/book-call" className='work-button'>Schedule Now</Link>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
}

export default WorkWithUs;
